import CartItemsFormManager from './CartItemsFormManager';

export default CartItemsFormManager;
